import { createQuery } from "react-query-kit";

import { getApi } from "@api/apiPath/util";
import { axiosClient } from "@api/clients.ts";

import type { Fetcher } from "react-query-kit";

import type { IGetApiEntities } from "@api/apiPath";

export const createGetFunc = <
  TResponse,
  TPathParams extends object | undefined,
  TQueryParams extends object | undefined,
>(
  path: IGetApiEntities,
) => {
  type IVariables = TQueryParams extends undefined
    ? {
        pathParam: TPathParams;
      }
    : {
        pathParam: TPathParams;
      } & TQueryParams;

  const { key, getPath } = getApi(`${path}.get`);

  const getFunc: Fetcher<TResponse, IVariables> = (
    { pathParam, ...restParam },
    { signal },
  ) => {
    return axiosClient.get(getPath(pathParam as never), {
      params: restParam,
      signal,
    });
  };

  return { getFunc, key };
};

export const createGetHook = <TResponse, TVariables>(
  key: string,
  getFunc: Fetcher<TResponse, TVariables>,
) => {
  const useGet = createQuery<TResponse, TVariables>({
    queryKey: [key],
    fetcher: getFunc,
  });

  return { useGet };
};

export const createGetApi = <
  TResponse,
  TPathParams extends object | undefined,
  TQueryParams extends object | undefined,
>(
  path: IGetApiEntities,
) => {
  const { key, getFunc } = createGetFunc<TResponse, TPathParams, TQueryParams>(
    path,
  );
  const { useGet } = createGetHook(key, getFunc);

  return { getFunc, useGet };
};
